export async function status(res) {
  if (res.status >= 200 && res.status < 300) {
    return res.json();
  }
  // Try to extract the API's error message from the response body
  let message = res.statusText;
  try {
    const body = await res.json();
    // Django REST framework returns errors as { field: ["msg"] } or { detail: "msg" }
    if (body.detail) {
      message = body.detail;
    } else {
      const parts = Object.entries(body).map(([field, msgs]) => {
        const text = Array.isArray(msgs) ? msgs.join(' ') : msgs;
        return field === 'non_field_errors' ? text : `${field}: ${text}`;
      });
      if (parts.length) message = parts.join(' | ');
    }
  } catch (_) {}
  throw new Error(message);
}